import React from 'react';
import { Head } from '@inertiajs/react';
import translate from '@/utils/translate';

export default function Maintenance({ page }) {
    if (!page) {
        return (
            <>
                <Head title={translate('maintenance.title')} />
                <div className="maintenance-wrapper">
                    <div className="glass-card">
                        {/* ������ Font Awesome ����� �� �������� */}
                        <div className="icon-code">
                            <i className="fas fa-screwdriver-wrench"></i>
                        </div>
                        <h1 className="main-title">{translate('maintenance.title')}</h1>
                        <p className="desc-message">{translate('maintenance.message')}</p>
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <Head title={page.content?.title || translate('maintenance.title')} />
            <div dangerouslySetInnerHTML={{ __html: page.content?.content || '' }} />
        </>
    );
}